import styled, { css } from 'styled-components';
import { getStaticUrl } from '@anwb/browser';
import { pxToRem } from '@anwb/style-utilities';
export const ICON_SIZES = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 22,
    xxl: 28,
    xxxl: 34,
    jumbo: 40,
    'jumbo-xl': 50,
    'jumbo-xxl': 60,
    'jumbo-xxxl': 70,
    mega: 80,
};
export const iconContainerStyles = ({ $size, $type, $variant, }) => {
    const iconSize = pxToRem(ICON_SIZES[$size]);
    return css `
		background-color: currentColor;
		display: flex;
		mask: url(${`https://${getStaticUrl()}/packages/anwb-icons/${$type}/${$variant}.svg`}) no-repeat
			center right;
		min-height: ${iconSize};
		width: ${iconSize};
	`;
};
export const IconContainer = styled.span `
	${iconContainerStyles}
`;
//# sourceMappingURL=icon.styled.js.map